export { getIvsClientId } from '@shopee-user/shared-customization-logic/src/ivs/config';

enum IvsEventType {
  Login = 34,
  OneCredentialLogin = -1,
}

export const getLoginIvsEventType = (): number => {
  return IvsEventType.Login;
};

export const getOneCredentialLoginIvsEventType = (): number => {
  return IvsEventType.OneCredentialLogin;
};
